import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IconSet } from "../../types/icon-set";
import { IconName } from "../../types/icon-name";
import { IconRotate } from "../../types/icon-rotate";

@Component({
  selector: "icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input() set: IconSet = "typcn";
  @Input() name: IconName;
  @Input() rotate: IconRotate | undefined;
  @Input() size: number | string = 24;
  @Input() strokeWidth: number = 2;
}
